import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table, TableBody, TableCell, TableHead, TableHeadCell, TableRow, Button, Select, TextInput } from 'flowbite-react';
import { TrashIcon } from '@heroicons/react/24/outline';
import LoadingSpinner from '../../components/LoadingSpinner';

const MergetagManager = () => {
  const [tags, setTags] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    type: 'Texto',
    value: '',
  });
  const [error, setError] = useState(null);

  const fetchTags = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${((import.meta.env.VITE_ENV == 'development') ? import.meta.env.VITE_BACKEND_LOCAL : import.meta.env.VITE_BACKEND)}/mergetags`,
        { withCredentials: true },
      );
      setTags(response.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTags();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.type) {
      alert('Nombre y tipo son obligatorios');
      return;
    }
    setIsLoading(true);
    try {
      const response = await axios.post(
        `${((import.meta.env.VITE_ENV == 'development') ? import.meta.env.VITE_BACKEND_LOCAL : import.meta.env.VITE_BACKEND)}/mergetag/create`,
        formData,
        { withCredentials: true },
      );
      setTags([...tags, response.data.tag]);
      setFormData({ name: '', type: 'Texto', value: '' });
    } catch (err) {
      console.error('Error al crear mergetag:', err);
      alert('Error al crear mergetag');
    } finally {
      setIsLoading(false);
    }
  };

  const handleRemove = async (id) => {
    const confirma = confirm('Confirma la eliminación del mergetag?');
    if (!confirma) return;
    setIsLoading(true);
    try {
      await axios.delete(
        `${((import.meta.env.VITE_ENV == 'development') ? import.meta.env.VITE_BACKEND_LOCAL : import.meta.env.VITE_BACKEND)}/mergetag/${id}/delete`,
        { withCredentials: true },
      );
      setTags(tags.filter((t) => t.id !== id));
    } catch (err) {
      console.error('Error al eliminar mergetag:', err);
      alert('Error al eliminar mergetag');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {isLoading && <LoadingSpinner message="Procesando..." size="md" color="blue" fullScreen={false} />}
      <form onSubmit={handleSubmit} className="space-y-4 mb-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-white">
              Nombre*
            </label>
            <TextInput
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Ej: Client.Name"
            />
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-white">
              Tipo*
            </label>
            <Select
              name="type"
              value={formData.type}
              onChange={handleChange}
            >
              <option value="Texto">Texto</option>
              <option value="Lista">Lista</option>
            </Select>
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-white">
              Valor
            </label>
            <TextInput
              name="value"
              value={formData.value}
              onChange={handleChange}
              placeholder="Texto: placeholder | Lista: valores separados por coma"
            />
          </div>
        </div>
        <div className="flex justify-end">
          <Button type="submit" color="blue">
            Agregar mergetag
          </Button>
        </div>
      </form>

      {error && <div className="text-red-500 mb-2">{error}</div>}

      <div className="overflow-x-auto">
        <Table>
          <TableHead>
            <TableHeadCell>Nombre</TableHeadCell>
            <TableHeadCell>Tipo</TableHeadCell>
            <TableHeadCell>Valor</TableHeadCell>
            <TableHeadCell>
              <span className="sr-only">Acciones</span>
            </TableHeadCell>
          </TableHead>
          <TableBody className="divide-y">
            {tags.map((tag) => (
              <TableRow key={tag.id} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                <TableCell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                  {tag.name}
                </TableCell>
                <TableCell>{tag.type}</TableCell>
                <TableCell className="text-xs text-gray-600">{tag.value}</TableCell>
                <TableCell className="inline-flex">
                  <a href="#" onClick={() => handleRemove(tag.id)}>
                    <TrashIcon className="w-5 text-red-500" title="Eliminar mergetag" />
                  </a>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default MergetagManager;

